<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-black p-4 sm:p-6">
    <div class="w-full max-w-sm sm:max-w-md">
      <div class="card !bg-white !text-gray-900 p-6 sm:p-8 rounded-lg shadow-lg">
        <div class="text-center mb-6 sm:mb-8">
          <h1 class="text-3xl sm:text-4xl font-bold text-capoeira-700 mb-2">⚙️</h1>
          <h2 class="text-2xl sm:text-3xl font-bold mb-1 sm:mb-2">Panel Administrativo</h2>
          <p class="text-xs sm:text-sm text-gray-600">Ingresa tus credenciales de admin</p>
        </div>

        <form @submit.prevent="iniciarSesion" class="space-y-4 sm:space-y-6">
          <div>
            <label class="block text-xs sm:text-sm font-semibold mb-1 sm:mb-2">Usuario</label>
            <input
              v-model="formulario.usuario"
              type="text"
              placeholder="admin"
              class="form-input w-full text-sm sm:text-base"
              :disabled="cargando"
            />
          </div>

          <div>
            <label class="block text-xs sm:text-sm font-semibold mb-1 sm:mb-2">Contraseña</label>
            <input
              v-model="formulario.password"
              type="password"
              placeholder="••••••••"
              class="form-input w-full text-sm sm:text-base"
              :disabled="cargando"
            />
          </div>

          <button
            type="submit"
            :disabled="cargando"
            class="w-full btn-primary text-sm sm:text-base py-2 sm:py-3"
          >
            {{ cargando ? '⏳ Autenticando...' : '✓ Iniciar Sesión' }}
          </button>
        </form>

        <div class="mt-4 sm:mt-6 p-3 sm:p-4 bg-blue-50 border border-blue-200 rounded">
          <p class="text-xs sm:text-sm text-blue-900 leading-relaxed">
            <strong>Credenciales de prueba:</strong><br>
            Usuario: <code class="bg-white px-1 rounded text-xs">admin</code><br>
            Contraseña: <code class="bg-white px-1 rounded text-xs">admin123</code>
          </p>
        </div>

        <Alert
          v-if="alerta.show"
          :type="alerta.type"
          :message="alerta.message"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../../composables/useAuth'
import Alert from '../../components/Alert.vue'

const router = useRouter()
const { loginAdmin } = useAuth()

const formulario = ref({
  usuario: '',
  password: ''
})

const cargando = ref(false)

const alerta = ref({
  show: false,
  type: 'info',
  message: ''
})

const mostrarAlerta = (type, message) => {
  alerta.value = { show: true, type, message }
}

const iniciarSesion = async () => {
  if (!formulario.value.usuario || !formulario.value.password) {
    mostrarAlerta('error', 'Por favor completa todos los campos')
    return
  }

  try {
    cargando.value = true
    await loginAdmin(formulario.value.usuario, formulario.value.password)
    mostrarAlerta('success', '✓ Bienvenido al panel de administración')

    // Redirigir a admin después de 1 segundo
    setTimeout(() => {
      router.push('/admin')
    }, 1000)
  } catch (err) {
    mostrarAlerta('error', err.message)
  } finally {
    cargando.value = false
  }
}
</script>
